// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"861ee193","963":"cfc3192a"}[chunkId] + ".chunk.js";
};